import React from "react";
import { Grid, Typography, Box, Container } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const AboutUs = () => {
  return (
    <JumboCardQuick wrapperSx={{ pt: 0 }}>
      <Container maxWidth="md">
        <Box py={4}>
          <Typography variant="h1" align="center" fontWeight={600} gutterBottom>
            About Us
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" paragraph>
                CodingPal.org is a interview preparation platform that aims at
                empowering learners in learning DSA/Problem Solving with
                visualizations.
              </Typography>

              <Typography variant="h6" paragraph>
                The idea was simple and straightforward. Each algorithm
                possesses a unique approach to handling data. While countless
                articles and videos created by dedicated individuals explain
                these algorithms, capturing every scenario in a single piece of
                content is a daunting task. This realization sparked the
                inspiration for CodingPal—a platform designed to visualize each
                algorithm’s distinct data-handling process. By offering a clear,
                visual representation, CodingPal empowers learners to grasp
                algorithms more intuitively. After all, visual comprehension is
                one of the most effective ways to master any subject.
              </Typography>

              <Typography variant="h6" paragraph>
                While visualizations are unique point of CodingPal.org, we try
                and cater every form of learning.
              </Typography>

              <Typography variant="h6" component="div">
                <Box component="ol" pl={2} mb={0}>
                  <li>
                    For people who prefer to learn through articles, we have
                    provided article tutorials of all appraoches for 400+
                    problems in C++, Python,JS, Java.
                  </li>
                  <li>
                    For people who prefer to learn through videos, we have
                    provided video tutorials of all appraoches for around 200+
                    problems in C++, Python,JS, Java. Thats true seperate videos
                    for each programming languages.
                  </li>
                  <li>
                    For people who prefer to learn through code, we have
                    provided code snippets of all appraoches for 400+ problems
                    in C++, Python,JS, Java.
                  </li>
                </Box>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </JumboCardQuick>
  );
};

export default AboutUs;
